import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

interface IWelcome_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IWelcome_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  ReadFromSessionStorage: string;
  ReadFromSessionStorage_dummy: string;
  SetValueOf: any;
  SetValueOf_dummy: any;
  ChangeVisibilityOf: string;
  ChangeVisibilityOf_dummy: string;
  WriteToSessionStorage: any;
  WriteToSessionStorage_dummy: any;
  VerifyCustomerWithSms: any;
  VerifyCustomerWithSms_dummy: any;
  SetFocusTo: any;
  SetFocusTo_dummy: any;
  CGC_VerifyCustomerCheck: any[];
  CGC_VerifyCustomerCheck_dummy: any[];
  CGC_VerifyCustomerUpdate: number;
  CGC_VerifyCustomerUpdate_dummy: number;
  NAVIGATE: any;
  NAVIGATE_dummy: any;
  IfThenElse: boolean;
  IfThenElse_dummy: boolean;
  isComp607100Visible: "visible" | "hidden";
  isComp950363Visible: "visible" | "hidden";
  isComp79536Visible: "visible" | "hidden";
  isComp317437Visible: "visible" | "hidden";
  isComp430602Visible: "visible" | "hidden";
  isComp578284Visible: "visible" | "hidden";
}

export class Welcome_ScreenBase extends React.PureComponent<IWelcome_ScreenProps, any> {
  ml = [
    {
      Id: "17674926-0bc7-4f1a-91e6-cf803751ca13",
      Name: "en_US",
      ShortName: "English",
      IsDefault: true,
      LanguagePhrases: []
    },
    {
      Id: "c13d1d6a-344d-473d-b329-5cd6ebdd6c3c",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 690927, PropertyName: "value", Value: "Hoş geldiniz!" },
        { Id: 367208, PropertyName: "value", Value: "Hediye çekiniz burada sizi bekliyor!" },
        {
          Id: 75480,
          PropertyName: "value",
          Value:
            "Hediye çeklerini görmek için telefon numaranızı girin ve size SMS ile gönderilen doğrulama kodunu kullanarak devam edin. Hepsi bu kadar!"
        },
        { Id: 351162, PropertyName: "value", Value: "Müşteri Doğrulama" },
        { Id: 626764, PropertyName: "label", Value: "Yenile" },
        { Id: 237754, PropertyName: "value", Value: "Telefon Numarası" },
        { Id: 156064, PropertyName: "placeholder", Value: "(5__)___ __ __" },
        { Id: 278920, PropertyName: "label", Value: "Doğrulama Kodu Gönder" },
        { Id: 232332, PropertyName: "value", Value: "Telefon Numarası" },
        { Id: 800629, PropertyName: "placeholder", Value: "(5__)___ __ __" },
        { Id: 257084, PropertyName: "value", Value: "Güvenlik Kodu" },
        { Id: 287947, PropertyName: "placeholder", Value: "_ _ _ _ _ _" },
        {
          Id: 317437,
          PropertyName: "value",
          Value: "Doğrulama kodu hatalı. Lütfen kısa mesaj (SMS) ile iletilen kodu girip tekrar deneyiniz."
        },
        { Id: 490103, PropertyName: "label", Value: "Kodu Doğrula" },
        { Id: 567783, PropertyName: "value", Value: "Müşteri Doğrulama" },
        { Id: 578284, PropertyName: "placeholder", Value: "Type here..." }
      ]
    }
  ];
  defaultML = "en_US";

  screenHash = "";

  constructor(props) {
    super(props);

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      ReadFromSessionStorage: "",
      SetValueOf: "",
      ChangeVisibilityOf: "",
      WriteToSessionStorage: "",
      VerifyCustomerWithSms: "",
      SetFocusTo: "",
      CGC_VerifyCustomerCheck: [],
      IfThenElse: false,
      isComp607100Visible: "visible",
      isComp950363Visible: "hidden",
      isComp79536Visible: "hidden",
      isComp317437Visible: "hidden",
      isComp430602Visible: "hidden",
      isComp578284Visible: "hidden"
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("welcome", "");
      return;
    }

    if (true) {
      await this.WelcomePageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("welcome", "");
  }

  componentWillUnmount() {}

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("welcome", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.WelcomePageInit();
    }
  };

  fillFormInitValues() {
    this.props.form.setFieldsValue({});
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form.setFields([
        {
          name: fieldName,
          errors: []
        }
      ]);
    }
  };

  WelcomePageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find((v) => !v.isValid && v.condition);
      if (invalidValidation) {
        const fieldIdMatch = invalidValidation.formName.match(/\d+/);
        if (fieldIdMatch) {
          const fieldId = fieldIdMatch[0];
          const fieldElement = document.getElementById(fieldId);
          if (fieldElement) {
            fieldElement.scrollIntoView({ behavior: "smooth", block: "center" });
            (fieldElement as HTMLElement).focus();
          }
        }
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.ReadFromSessionStorage = await ReactSystemFunctions.readFromSessionStorage("CusCodeNumber");

    this.props.form.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.WelcomePageInit1_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  WelcomePageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find((v) => !v.isValid && v.condition);
      if (invalidValidation) {
        const fieldIdMatch = invalidValidation.formName.match(/\d+/);
        if (fieldIdMatch) {
          const fieldId = fieldIdMatch[0];
          const fieldElement = document.getElementById(fieldId);
          if (fieldElement) {
            fieldElement.scrollIntoView({ behavior: "smooth", block: "center" });
            (fieldElement as HTMLElement).focus();
          }
        }
      }
      return true;
    }
    if (ReactSystemFunctions.isNotEmpty(ReactSystemFunctions.toString(this, this.state.ReadFromSessionStorage), null)) {
      stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
        this,
        "welcome_156064_value",
        ReactSystemFunctions.toString(this, this.state.ReadFromSessionStorage),
        null
      );

      this.props.form.setFieldsValue(formVars);
      this.setState(stateVars);
      KuikaAppManager.hideSpinner(this);
    } else {
      KuikaAppManager.hideSpinner(this);
    }

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  WelcomeComponent_626764_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find((v) => !v.isValid && v.condition);
      if (invalidValidation) {
        const fieldIdMatch = invalidValidation.formName.match(/\d+/);
        if (fieldIdMatch) {
          const fieldId = fieldIdMatch[0];
          const fieldElement = document.getElementById(fieldId);
          if (fieldElement) {
            fieldElement.scrollIntoView({ behavior: "smooth", block: "center" });
            (fieldElement as HTMLElement).focus();
          }
        }
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.ReadFromSessionStorage = await ReactSystemFunctions.readFromSessionStorage("CusCodeNumber");
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      "welcome_156064_value",
      ReactSystemFunctions.toString(this, stateVars.ReadFromSessionStorage),
      null
    );
    stateVars.ChangeVisibilityOf = await ReactSystemFunctions.changeVisibilityOf(
      this,
      "isComp607100Visible",
      "visible"
    );
    stateVars.ChangeVisibilityOf = await ReactSystemFunctions.changeVisibilityOf(this, "isComp950363Visible", "hidden");
    stateVars.ChangeVisibilityOf = await ReactSystemFunctions.changeVisibilityOf(this, "isComp79536Visible", "hidden");
    stateVars.ChangeVisibilityOf = await ReactSystemFunctions.changeVisibilityOf(this, "isComp317437Visible", "hidden");

    this.props.form.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  WelcomeComponent_278920_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    validations.push({
      isValid: ReactSystemFunctions.isEqualLength(
        ReactSystemFunctions.value(this, ReactSystemFunctions.value(this, "welcome_156064_value", "value", "", "", "")),
        "10"
      ),
      message: "*",
      formName: "welcome_156064_value",
      condition: true
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find((v) => !v.isValid && v.condition);
      if (invalidValidation) {
        const fieldIdMatch = invalidValidation.formName.match(/\d+/);
        if (fieldIdMatch) {
          const fieldId = fieldIdMatch[0];
          const fieldElement = document.getElementById(fieldId);
          if (fieldElement) {
            fieldElement.scrollIntoView({ behavior: "smooth", block: "center" });
            (fieldElement as HTMLElement).focus();
          }
        }
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.WriteToSessionStorage = await ReactSystemFunctions.writeToSessionStorage(
      "CusCodeNumber",
      ReactSystemFunctions.value(this, ReactSystemFunctions.value(this, "welcome_156064_value", "value", "", "", ""))
    );
    stateVars.ReadFromSessionStorage = await ReactSystemFunctions.readFromSessionStorage("CusCodeNumber");

    this.props.form.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.WelcomeComponent_278920_onClick1_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  WelcomeComponent_278920_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    validations.push({
      isValid: ReactSystemFunctions.isEqualLength(
        ReactSystemFunctions.value(this, ReactSystemFunctions.value(this, "welcome_156064_value", "value", "", "", "")),
        "10"
      ),
      message: "*",
      formName: "welcome_156064_value",
      condition: true
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find((v) => !v.isValid && v.condition);
      if (invalidValidation) {
        const fieldIdMatch = invalidValidation.formName.match(/\d+/);
        if (fieldIdMatch) {
          const fieldId = fieldIdMatch[0];
          const fieldElement = document.getElementById(fieldId);
          if (fieldElement) {
            fieldElement.scrollIntoView({ behavior: "smooth", block: "center" });
            (fieldElement as HTMLElement).focus();
          }
        }
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      PhoneNumber_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, ReactSystemFunctions.value(this, "welcome_156064_value", "value", "", "", "")),
        "string"
      )
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(this, "Welcome/WelcomeComponent_278920_onClick1_", localVar);
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.VerifyCustomerWithSms = result?.data.verifyCustomerWithSms;
    this.props.form.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.WelcomeComponent_278920_onClick2_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  WelcomeComponent_278920_onClick2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find((v) => !v.isValid && v.condition);
      if (invalidValidation) {
        const fieldIdMatch = invalidValidation.formName.match(/\d+/);
        if (fieldIdMatch) {
          const fieldId = fieldIdMatch[0];
          const fieldElement = document.getElementById(fieldId);
          if (fieldElement) {
            fieldElement.scrollIntoView({ behavior: "smooth", block: "center" });
            (fieldElement as HTMLElement).focus();
          }
        }
      }
      return true;
    }

    stateVars.WriteToSessionStorage = await ReactSystemFunctions.writeToSessionStorage(
      "VerifyCustomerId",
      ReactSystemFunctions.toString(this, this.state.VerifyCustomerWithSms?.id)
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      "welcome_578284_value",
      ReactSystemFunctions.toString(this, this.state.VerifyCustomerWithSms?.success),
      null
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      "welcome_800629_value",
      ReactSystemFunctions.toString(this, this.state.ReadFromSessionStorage),
      null
    );
    stateVars.ChangeVisibilityOf = await ReactSystemFunctions.changeVisibilityOf(this, "isComp607100Visible", "hidden");
    stateVars.ChangeVisibilityOf = await ReactSystemFunctions.changeVisibilityOf(
      this,
      "isComp950363Visible",
      "visible"
    );
    stateVars.SetFocusTo = await ReactSystemFunctions.setFocusTo("287947");

    this.props.form.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  WelcomeComponent_490103_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find((v) => !v.isValid && v.condition);
      if (invalidValidation) {
        const fieldIdMatch = invalidValidation.formName.match(/\d+/);
        if (fieldIdMatch) {
          const fieldId = fieldIdMatch[0];
          const fieldElement = document.getElementById(fieldId);
          if (fieldElement) {
            fieldElement.scrollIntoView({ behavior: "smooth", block: "center" });
            (fieldElement as HTMLElement).focus();
          }
        }
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.ChangeVisibilityOf = await ReactSystemFunctions.changeVisibilityOf(this, "isComp317437Visible", "hidden");
    stateVars.ReadFromSessionStorage = await ReactSystemFunctions.readFromSessionStorage("VerifyCustomerId");

    this.props.form.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.WelcomeComponent_490103_onClick1_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  WelcomeComponent_490103_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    validations.push({
      isValid: ReactSystemFunctions.isEqualLength(
        ReactSystemFunctions.value(this, ReactSystemFunctions.value(this, "welcome_156064_value", "value", "", "", "")),
        "10"
      ),
      message: "*",
      formName: "welcome_156064_value",
      condition: true
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });
    validations.push({
      isValid: ReactSystemFunctions.isEqualLength(
        ReactSystemFunctions.value(this, ReactSystemFunctions.value(this, "welcome_287947_value", "value", "", "", "")),
        "6"
      ),
      message: "*",
      formName: "welcome_287947_value",
      condition: true
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find((v) => !v.isValid && v.condition);
      if (invalidValidation) {
        const fieldIdMatch = invalidValidation.formName.match(/\d+/);
        if (fieldIdMatch) {
          const fieldId = fieldIdMatch[0];
          const fieldElement = document.getElementById(fieldId);
          if (fieldElement) {
            fieldElement.scrollIntoView({ behavior: "smooth", block: "center" });
            (fieldElement as HTMLElement).focus();
          }
        }
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      Id_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toGuid(this, this.state.ReadFromSessionStorage),
        "Guid"
      ),
      CusCardNumber_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, ReactSystemFunctions.value(this, "welcome_156064_value", "value", "", "", "")),
        "string"
      ),
      VerificationCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, ReactSystemFunctions.value(this, "welcome_287947_value", "value", "", "", "")),
        "string"
      )
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(this, "Welcome/WelcomeComponent_490103_onClick1_", localVar);
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.CGC_VerifyCustomerCheck = result?.data.cgC_VerifyCustomerCheck;
    this.props.form.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.WelcomeComponent_490103_onClick2_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  WelcomeComponent_490103_onClick_if2 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find((v) => !v.isValid && v.condition);
      if (invalidValidation) {
        const fieldIdMatch = invalidValidation.formName.match(/\d+/);
        if (fieldIdMatch) {
          const fieldId = fieldIdMatch[0];
          const fieldElement = document.getElementById(fieldId);
          if (fieldElement) {
            fieldElement.scrollIntoView({ behavior: "smooth", block: "center" });
            (fieldElement as HTMLElement).focus();
          }
        }
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      Id_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toGuid(this, this.state.ReadFromSessionStorage),
        "Guid"
      ),
      Status_0: ReactSystemFunctions.convertToTypeByName(1, "number")
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(this, "Welcome/WelcomeComponent_490103_onClick_if2", localVar);
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.CGC_VerifyCustomerUpdate = result?.data.cgC_VerifyCustomerUpdate;
    this.props.form.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.WelcomeComponent_490103_onClick_if21_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  WelcomeComponent_490103_onClick_if21_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find((v) => !v.isValid && v.condition);
      if (invalidValidation) {
        const fieldIdMatch = invalidValidation.formName.match(/\d+/);
        if (fieldIdMatch) {
          const fieldId = fieldIdMatch[0];
          const fieldElement = document.getElementById(fieldId);
          if (fieldElement) {
            fieldElement.scrollIntoView({ behavior: "smooth", block: "center" });
            (fieldElement as HTMLElement).focus();
          }
        }
      }
      return true;
    }

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "HediyeCekleri",
      "VerifyCustomerId",
      ReactSystemFunctions.value(
        this,
        stateVars.CGC_VerifyCustomerCheck?.length > 0
          ? stateVars.CGC_VerifyCustomerCheck[0].id
          : this.state.CGC_VerifyCustomerCheck?.length > 0
          ? this.state.CGC_VerifyCustomerCheck[0].id
          : null
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "Welcome",
      "HediyeCekleri",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true
    );

    this.props.form.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  WelcomeComponent_490103_onClick_else2 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find((v) => !v.isValid && v.condition);
      if (invalidValidation) {
        const fieldIdMatch = invalidValidation.formName.match(/\d+/);
        if (fieldIdMatch) {
          const fieldId = fieldIdMatch[0];
          const fieldElement = document.getElementById(fieldId);
          if (fieldElement) {
            fieldElement.scrollIntoView({ behavior: "smooth", block: "center" });
            (fieldElement as HTMLElement).focus();
          }
        }
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.ChangeVisibilityOf = await ReactSystemFunctions.changeVisibilityOf(
      this,
      "isComp317437Visible",
      "visible"
    );

    this.props.form.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  WelcomeComponent_490103_onClick2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find((v) => !v.isValid && v.condition);
      if (invalidValidation) {
        const fieldIdMatch = invalidValidation.formName.match(/\d+/);
        if (fieldIdMatch) {
          const fieldId = fieldIdMatch[0];
          const fieldElement = document.getElementById(fieldId);
          if (fieldElement) {
            fieldElement.scrollIntoView({ behavior: "smooth", block: "center" });
            (fieldElement as HTMLElement).focus();
          }
        }
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.CGC_VerifyCustomerCheck?.length > 0
            ? stateVars.CGC_VerifyCustomerCheck[0].isVerified
            : this.state.CGC_VerifyCustomerCheck?.length > 0
            ? this.state.CGC_VerifyCustomerCheck[0].isVerified
            : null
        ),
        "1"
      )
    ) {
      isErrorOccurred = await this.WelcomeComponent_490103_onClick_if2();
      if (isErrorOccurred) return true;
    } else {
      isErrorOccurred = await this.WelcomeComponent_490103_onClick_else2();
      if (isErrorOccurred) return true;
    }

    this.props.form.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [] as number[];
    if (window.kuika?.serverRequestCount > 0 && pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.WelcomePageInit();
    }
  }
}
